import React, { useCallback, useState } from "react";
import classNames from "classnames";
import { Link } from "./link";

const BannerPromoFragment = ({ item, closeBanner, itemLength }) => {
  const [bannerOpen, setBannerOpen] = useState(false);
  const toggleOpen = useCallback(() => setBannerOpen((value) => !value), []);

  return (
    <div
      className={classNames(
        "banner-promo-wrapper px-0 align-self-end col-12",
        itemLength > 1 ? "col-md-4 mr-2" : "col-sm-8 col-md-6"
      )}
    >
      <div className="banner-promo__arrow-wrapper">
        <button className="banner-promo__arrow" name={item.articleId} onClick={toggleOpen}>
          <span
            className={classNames(
              bannerOpen ? "banner-promo__arrow--bottom" : "banner-promo__arrow--top"
            )}
          ></span>
        </button>
      </div>
      <div
        className={classNames(`banner-promo`, {
          open: bannerOpen,
        })}
      >
        <button className="banner-promo__title">{item.title}</button>
        <div>
          <button
            className="banner-promo__close"
            name={item.articleId}
            onClick={closeBanner}
            aria-label="Close"
          ></button>
        </div>
      </div>
      <div
        className={classNames(
          "banner-promo__content-text banner-promo__content",
          bannerOpen && "open"
        )}
      >
        <div className="banner-promo__content-title">{item.internalTitle}</div>
        <span
          className="banner-promo__content-abstract"
          dangerouslySetInnerHTML={{ __html: item.internalDescription }}
        ></span>
        {item.ctaLabel && item.ctaContent && item.ctaContent && (
          <Link
            to={item.ctaContent}
            className="prodotti__btn-wtb banner-promo__link w-80 mt-3 mb-2"
            target="_blank"
            rel="noopener noreferrer"
          >
            {item.ctaLabel}
          </Link>
        )}
      </div>
    </div>
  );
};

export default BannerPromoFragment;
